import { API } from '@utils/axios'

export async function fetchAllFoodCategoryGroups () {
  const response = await API.get('/FoodCategoryGroup')
  return response.data
}
